import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { Worksheet } from '../types/worksheet';

type GetWorksheetResponse = {
    worksheet: Worksheet;
};

async function getWorksheet(workpaperId: string, id?: string): Promise<GetWorksheetResponse> {
    const { data } = await api.get(`/workpapers/${workpaperId}/worksheets/${id}`);
    return data;
}

export function useWorksheet(id?: string, overrideWorkpaperId?: string, enabled = true): UseQueryResult<GetWorksheetResponse, AxiosError> {
    const { id: contextWorkpaperId } = useWorkpaperContext();
    const workpaperId = overrideWorkpaperId || contextWorkpaperId;
    return useQuery(['worksheets', id], () => getWorksheet(workpaperId, id), { enabled: Boolean(id) && enabled, keepPreviousData: true });
}
